import { reactive, ref } from "vue";
import {
  getInheritanceItem,
  updateInheritance,
  updateInheritanceNote,
  updateInheritanceDescription,
} from "../api";

export function useInheritanceItem(uuid) {
  const form = reactive({
    template_code: null,
    state_duty: null,
    number_certified_copies: null,
    status: "PROJECT",
    content: null,
    content_kz: null,
    content_en: null,
    contract_amount: 0,
    languages: [],
    fields: {},
  });

  const loading = ref(false);

  async function fetchInheritance(id) {
    loading.value = true;
    try {
      const data = await getInheritanceItem(id || uuid.value);
      if (data?.success && data.payload) {
        Object.assign(form, data.payload);
      }
      return data;
    } finally {
      setTimeout(() => (loading.value = false), 500);
    }
  }

  async function updateInheritanceItem(id, payload) {
    const data = await updateInheritance(id || uuid.value, payload);
    return data;
  }

  async function updateNote(note) {
    const data = await updateInheritanceNote(uuid.value, note);
    return data;
  }

  async function updateDescription(description) {
    const data = await updateInheritanceDescription(uuid.value, description);
    return data;
  }

  return {
    form,
    loading,
    fetchInheritance,
    updateInheritanceItem,
    updateNote,
    updateDescription,
  };
}
